const PARTNER_LABELS = {
  retinalyze: 'Retinalyze',
  mock: 'Mock',
}

export function partnerLabel(name) {
  if (!name) return ''
  return PARTNER_LABELS[name] || name
}

export function connectorNotificationLabels(event, t) {
  const data = event || {}
  const summary = data.summary || {}
  const completed = summary.completed || 0
  const errored = summary.error || 0
  const isCompleted = data.event === 'batch-completed'

  return {
    title: isCompleted ? t('connector.notificationCompleted') : t('connector.notificationProcessing'),
    body: t('connector.notificationSummary', {
      partner: partnerLabel(data.partner),
      completed,
      errored,
    }),
    icon: 'fa-plug',
  }
}

export default {
  partnerLabel,
  connectorNotificationLabels,
}
